/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { Text, TEXT_VARIANTS, EntityLink } from "..";
import { COLORS } from "../../shared/theme";

const TYPE_LINK_MAP = {
  person: "/person/asdf",
  collection: "/collection/asdf",
  user: "/asdf",
  article: "/article/asf",
};

export const Tagline: React.FC<{
  text: string;
  entities: Array<{ type: string; name: string }>;
}> = ({ text, entities }) => (
  <Text
    variant={TEXT_VARIANTS.T20}
    css={css`
      color: ${COLORS.SILVER};
    `}
  >
    {text.split(" ").map((word) => {
      if (word.includes("$"))
        return (
          <React.Fragment key={`tagline-${text}-${word}`}>
            <EntityLink
              to={
                (TYPE_LINK_MAP as any)[entities[parseInt(word[1])].type as any]
              }
            >
              {entities[parseInt(word[1])].name}
            </EntityLink>{" "}
          </React.Fragment>
        );
      else
        return (
          <React.Fragment
            key={`tagline-${text}-${word}`}
          >{`${word} `}</React.Fragment>
        );
    })}
  </Text>
);
